import React from 'react';
import { useSelector } from 'react-redux';

import { MAX_CHARACTERS_AMOUNT } from '../../constants/aiChatbot';

import styles from './AiChatbot.module.scss';

export function PromptInfo() {
  const { searchText } = useSelector((state) => state.aiChatbot);

  return (
    <div className={styles.promptInfoContainer}>
      <div>CymBot can make mistakes. Check important info.</div>
      <div className={searchText.length > MAX_CHARACTERS_AMOUNT ? styles.errorTooManyCharacters : ''}>
        {searchText.length}/1000 characters
      </div>
    </div>
  );
}
